// Drop events that originated inside the corptools plugin when its own Sentry
// instance is confirmed active — prevents the same error landing in two projects.
export function beforeSend(event, hint) {
  if (window.__CORPTOOLS_SENTRY_ACTIVE !== true) {
    return event;
  }
  const frames = event?.exception?.values?.flatMap(
    v => v?.stacktrace?.frames ?? []
  ) ?? [];
  return frames.some(f => /frontend-wp-corptools-plugin/i.test(f?.filename ?? ''))
    ? null
    : event;
}
